module.exports = __webpack_public_path__ + "static/img/banner.c5fdc59.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/titbits/banner.png
// module id = dUg/
// module chunks = 1